import React, { Component } from 'react';
import { history } from '../../helpers/history';
import SaayaLogo from '../../static/images/saaya-logo-new.png';

class PrivacyAndPolicy extends Component {
	redirectToHome() {
		history.replace('/home');
	}

	render() {
		return (
			<div>
				<div className="container  w-100">
					<div className="text-center">
						<img
							className="logo confirm-logo"
							src={SaayaLogo}
							alt="SaayaHealth logo"
						/>

						<div className="p-5">
							<u>
								<h5 className="display-5">Privacy Policy for Saaya Health</h5>
								<p>Effective Date: Wednesday, October 11, 2023</p>
							</u>
						</div>
					</div>

					<div className='pb-5'>
						<p style={{ textAlign: 'left' }}>
							Welcome to Saaya Health ("we," "our," or "us"). We are committed to protecting your privacy and providing you with a secure and enjoyable experience while using our digital services. This Privacy Policy outlines our practices regarding the collection, use, and disclosure of your personal information when you access and use our Wellbeing services and website. <br />
							By using our services, you consent to the practices described in this Privacy Policy. Please take a moment to read this policy carefully to understand how we handle your personal information.
						</p>

						<div>
							<p style={{ textDecoration: 'underline' }}>1. Information We Collect</p>
							<p>
								We collect various types of information to provide and improve our wellbeingservices:
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>1.1. Personal Information</p>
							<p>
								<li>Contact Information: This may include your name, email address, postal address, and phone number.</li>
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>1.2. Usage Information</p>
							<p>
								<li>Log Data: We collect information about your device, browser type, IP address, and pages you visit on our website.</li>
								<li>Cookies and Tracking Technologies: We use cookies and similar technologies to gather information about your interactions with our website and services. You can manage cookie preferences through your browser settings.</li>
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>1.3. User-Generated Content</p>
							<p>
								We may collect and store content you submit to us, such as reviews, comments, or messages.
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>2. How We Use Your Information</p>
							<p>
								We use your personal information for the following purposes:
							</p>
							<p>
								<li>
									Providing wellbeing Services: To deliver wellbeingservices, and including appointments.
								</li>
								<li>
									Improving Our Services: To analyze usage data and improve the functionality and content of our digital services.
								</li>
								<li>
									Communications: To send you updates, service notifications, and important information.
								</li>
								<li>
									User Support: To respond to your inquiries, provide technical support, and address issues you report.
								</li>
								<li>
									Legal Compliance: To comply with legal obligations and protect our rights and the rights of others.
								</li>
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>3. How We Share Your Information</p>
							<p>
								We may share your personal information in the following circumstances:
							</p>
							<p>
								<li>
									Service Providers: We may engage third-party service providers to assist us in delivering well beings ervices, and they may have access to your personal information.
								</li>
								<li>
									Legal Compliance: We may disclose information if required by law, government agencies, or to protect our legal rights.
								</li>
								<li>
									Business Transfers: In the event of a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred.
								</li>
								<li>
									Consent: We may share your information with your explicit consent.
								</li>
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>4: Controlling Your Personal Information</p>
							<p>
								If you wish to close your account, please email us at contact@saayahealth.com on which Saaya Health will delete your account and the related information at your request as soon as reasonably possible. Please note, however, that Saaya Health reserves the right to retain information from closed accounts, including to comply with law, prevent fraud, resolve disputes, enforce the Agreement, insurance claims post settlement and take other actions permitted by law.
								<br />
								You must promptly notify us if any of your account data is lost, stolen or used without permission.
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>5. Security</p>
							<p>
								We take security seriously and use industry-standard measures to protect your personal information. However, no method of transmission over the internet or electronic storage is entirely secure, so we cannot guarantee absolute security.

							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>6. Children's Privacy</p>
							<p>
								Our services are not intended for children under 13 years of age. If we become aware that we have collected personal information from a child under 13, we will delete it promptly.
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>7. Changes to this Privacy Policy</p>
							<p>
								We may update this Privacy Policy from time to time to reflect changes in our practices or for legal, operational, or regulatory reasons. We will notify you of any material changes.
							</p>
						</div>
						<div>
							<p style={{ textDecoration: 'underline' }}>8. Contact Us</p>
							<p>
								If you have questions, concerns, or requests related to your privacy or this Privacy Policy, please contact us at contact@saayahealth.com.<br/>
								Thank you for trusting Saaya Health` with your health and well-being. Your privacy is essential to us, and we are committed to protecting it.
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default PrivacyAndPolicy;



// WEBPACK FOOTER //
// ./src/components/PrivacyAndPolicy/index.js